// extracted by mini-css-extract-plugin
export default {"wrapper":"oU-z","availablePromoMessagesLabel":"pU-z","promoMessageList":"qU-z","promoMessage":"rU-z","appliedPromoMessage":"sU-z","promoMessageAmount":"tU-z"};